import Vue from 'vue'
import {formatDate, getListData, setDataMap, setListData} from "../utils/tool";

Vue.prototype.formatDate = formatDate
Vue.prototype.getListData = getListData
Vue.prototype.setDataMap = setDataMap
Vue.prototype.setListData = setListData

